import { Link } from 'react-router-dom';
import { GraduationCap, Package, Sparkles } from 'lucide-react';
import { StatusBadge } from '@/design/components';
import { ModuleGate } from '@/access/Gate';
import { useCurrentSpotlight, useImageUrl } from './api';

/**
 * "הכר את המוצר החדש" במסך הבית (PRD 5.1.5).
 *
 * מוצג רק כשיש פרסום שרלוונטי לעובד, ונעלם מעצמו כשאין. כרטיס ריק
 * שכתוב בו "אין מוצר חדש" הוא רעש.
 */
export function SpotlightCard() {
  return (
    <ModuleGate module="learning_products" fallback={null}>
      <SpotlightCardInner />
    </ModuleGate>
  );
}

function SpotlightCardInner() {
  const spotlight = useCurrentSpotlight();
  const image = useImageUrl(spotlight.data?.image_path);

  if (!spotlight.data) return null;
  const item = spotlight.data;

  return (
    <section className="grid gap-3 rounded-lg bg-raised p-4 shadow-card">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 className="m-0 flex items-center gap-2 font-display text-display-m font-semibold">
          <Sparkles size={20} strokeWidth={1.75} aria-hidden="true" />
          הכר את המוצר
        </h2>
        {item.quiz_passed && <StatusBadge tone="good">עברת את החידון</StatusBadge>}
      </div>

      <Link
        to={`/products/${item.product_id}`}
        className="flex items-center gap-3 no-underline"
      >
        <span className="grid size-16 shrink-0 place-items-center overflow-hidden rounded-sm bg-olive-soft">
          {image.data ? (
            <img src={image.data} alt="" className="size-full object-cover" />
          ) : (
            <Package size={28} strokeWidth={1.75} aria-hidden="true" className="text-muted" />
          )}
        </span>
        <span className="grid min-w-0 gap-0.5">
          <span className="text-title font-medium text-ink">{item.name}</span>
          {item.headline && (
            <span className="line-clamp-2 text-body-sm text-muted">{item.headline}</span>
          )}
        </span>
      </Link>

      {item.quiz_id && !item.quiz_passed && (
        <Link
          to={`/learning/quiz/${item.quiz_id}`}
          className="inline-flex w-fit items-center gap-2 rounded-pill bg-charcoal px-4 py-2 text-body-sm font-medium text-on-charcoal no-underline"
        >
          <GraduationCap size={20} strokeWidth={1.75} aria-hidden="true" />
          לחידון על המוצר
        </Link>
      )}
    </section>
  );
}
